export default __webpack_public_path__ + "static/media/user-manual-sidebar.6c7f6a25.svg";